import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tab } from '@headlessui/react';
import Tabs from 'components/v2/navs/Tabs';
import ShipmentDocuments from 'components/modules/tools/components/ShipmentDocuments';
import InvoiceDocuments from 'components/modules/tools/components/InvoiceDocuments';
import PayoutDocuments from 'components/modules/tools/components/PayoutDocuments';
const getTabs = (t) => [
    { id: 'shipmentDocumentsTab', name: t('SHIPMENT_DOCUMENTS') },
    { id: 'invoicesTab', name: t('INVOICE', { count: 2 }) },
    { id: 'payoutsTab', name: t('PAYOUT', { count: 2 }) },
];
export default function ExportDocuments() {
    const { t } = useTranslation();
    return (React.createElement(Tabs, { tabs: getTabs(t) },
        React.createElement(Tab.Panel, null,
            React.createElement(ShipmentDocuments, null)),
        React.createElement(Tab.Panel, null,
            React.createElement(InvoiceDocuments, null)),
        React.createElement(Tab.Panel, null,
            React.createElement(PayoutDocuments, null))));
}
